import {lazy} from 'react';
import {RouteType} from '../../global/types/route.type';
import {appRoutes} from './appRoutes';

export const noAuthRoutes: RouteType[] = [
    {
        key: 'TenantNotFound',
        authorities: [],
        path: appRoutes.public.tenantNotFound(),
        component: lazy(() => import('../../views/notFound/TenantNotFound')),
    },
    {
        key: 'userInvitation',
        path: appRoutes.public.userInvitation(),
        component: lazy(() => import('views/auth/UserInvitation')),
        authorities: [],
    },
];

export default noAuthRoutes;
